import { ListingProfileWidgetPortalsRowContent } from './ListingProfileWidgetPortalsRowContent'
import { ListingProfileWidgetPortalsRowWrapper } from './ListingProfileWidgetPortalsRowWrapper'

import * as styles from './ListingProfileWidgetPortalsRow.module.css'

function ListingProfileWidgetPortalsRow({ publication }) {
  return (
    <ListingProfileWidgetPortalsRowWrapper
      className={styles.static}
      linkClassName={styles.link}
      publication={publication}
    >
      <ListingProfileWidgetPortalsRowContent
        nameClassName={styles.name}
        publication={publication}
      />
    </ListingProfileWidgetPortalsRowWrapper>
  )
}

export default ListingProfileWidgetPortalsRow
